<script>
import headNav from '../../src/components/headNav.vue'
import {mapGetters} from "vuex";
import router from "../router";
import {getMyPhone, updateUserInfo} from "../api/api";
export default {
  name: "home",
  components:{headNav},
  computed:{
    ...mapGetters(['userInfo'])
  },
  data(){
    return{
      numberText:'',
      arr:[
        '11111','222222','33333'
      ],
      pathText:'6666666',
      fullscreenLoading:false,
      page1:1,
      page2:1,
      total1:null,
      total2:null,
      myList:[]
    }
  },
  created() {

  },
  mounted() {
    this.getMyPhoneList()
    this.getUpdateUserInfo()
  },
  methods:{
    getUpdateUserInfo(){
      updateUserInfo({
        id:this.userInfo.id
      }).then(res => {
        console.log(res,"打印res")
        this.$store.dispatch('setUserInfo', res.data.data)
      })
    },
    getMyPhoneList(){
      getMyPhone({
        id:this.userInfo.id,
        page:this.page1,
        limit:9
      }).then(res => {
        console.log(res)
        this.total1 = res.data.data.total
        this.myList = res.data.data.data
      })
    },
    go(name){
      router.push({
        name
      })
    },
    getMapping(list,num) {
      let len = list.length
      let newList = []
      if (len) {
        var chunk = num
        for (var i = 0, j = len; i < j; i += chunk) {
          newList.push(list.slice(i, i + chunk))
        }
      }
      console.log(newList,'打印分组后的数组')
      return newList
    },
    onCopy() {
      this.$copyText(this.pathText).then(
        e=>{
          console.log('复制成功：', e);
          this.$message({
            message: 'copied',
            type:'success'
          });
        },
        e=>{
          console.log('复制失败：', e);
        }
      )
    },
    out(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(246,245,245,0.7)'
      });
      setTimeout(() => {
        loading.close();
        this.$store.commit('LOG_OUT', 0)
        this.go('home')
      }, 2000);

    },
    //充值
    Recharge(){
      router.push({
        name:'BalanceDetails'
      })
    },
    pageChange1(e){
      console.log(e)
      this.page1 = e
      this.getMyPhoneList()
    },
    goMes(e){
      console.log(e,'打印e00')
      router.push(
        {
          name:'freeDetail',
          query:{
            id:e.id,
            phone:e.phone
          }
        }
      )
    }
  }

}
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <b-container class="ok" fluid style="margin-bottom: 30px;margin-top: 30px">
      <b-row>
        <b-col sm="4">
          <div class="leftMesBox" >
            <div style="width: 60px;margin: 0 auto">
                <img :src="userInfo.avatar" style="width:60px;height:60px;border-radius:50%;margin: 0 auto" alt="">
            </div>
            <div style="text-align: center">{{userInfo.name}}</div>
            <div style="text-align:center;margin-top:20px;margin-bottom: 20px">
                {{userInfo.email}}
            </div>
            <div class="line2">
              <div style="font-weight: bold;">balance: ${{userInfo.balance}}</div>
              <div><b-button variant="outline-success" size="sm" @click="Recharge">Recharge</b-button></div>
            </div>
            <div class="line" @click="go('edit')">
              Edit information
            </div>
            <div class="line" @click="go('message')">
              message
            </div>
            <div class="line" @click="go('orderList')">
              My Order
            </div>
            <div class="line" @click="go('records')">
              Transaction records
            </div>
<!--            <div class="line" @click="go('orderList')">-->
<!--              Order List-->
<!--            </div>-->
            <div style="margin-top:20px">
                <b-button block variant="danger" @click="out()">LOGOUT</b-button>
            </div>
          </div>
        </b-col>
        <b-col sm="8">
          <div style="font-weight: 600;font-size: 24px">
            My Active numbers
          </div>
          <b-container fluid style="margin: 30px 0px">
            <b-row style="margin-bottom: 20px">
              <b-col sm="4" v-for="(item,index) in myList" :key="index">
                <div class="module1" >
                  <div class="headModule1">
                    <img v-if="item.country" :src="item.country.image" style="width: 40px;height: 30px" alt="">
                    <div v-if="item.country" style="font-size: 22px">{{item.country.name}}</div>
                  </div>
                  <div class="phoneModule1">
                    <div style="display: flex">
                      <div style="font-size: 20px;color: #1C90F3;font-weight: 600;margin-right: 5px">+{{item.phone}}</div>
                      <img src="../../static/copy.png" @click="onCopy()" style="width: 12px;height: 12px;margin-top: 10px" alt="">
                    </div>
                  </div>
                  <div class="onlineModule1">
                    Online
                  </div>
                  <div style="width: 82px;height: 48px;margin: 10px auto">
                    <button type="button" class="btn btn-outline-dark  btn-lg" @click="goMes(item)">Select</button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-container>
              <b-row style="margin-bottom: 20px;margin-bottom: 15px">
                <b-col sm="4" offset-sm="4">
                  <div>
                    <el-pagination
                      background
                      :page-size='9'
                      layout="prev, pager, next"
                      @current-change="pageChange1"
                      :total="total1">
                    </el-pagination>
                  </div>
                </b-col>
              </b-row>
            </b-container>
<!--            <div style="font-weight: 600;font-size: 24px">-->
<!--                Available numbers-->
<!--            </div>-->
<!--            <b-row style="margin: 30px 0">-->
<!--                <b-col sm="6" v-for="(item,index) in 4" :key="index" style="margin-bottom:15px">-->
<!--                <div class="module">-->
<!--                    <div class="moduleHead">-->
<!--                    <div style="margin-right: 10px;padding: 5px 0;box-sizing: border-box">-->
<!--                        <img src="../../static/1.png" style="width: 80px;height: 40px" alt="">-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <div style="font-weight: 600;font-size: 16px">United Kingdom</div>-->
<!--                        <div style="font-size: 14px;color: #2080E4;font-weight: 600">+447******152</div>-->
<!--                    </div>-->
<!--                    </div>-->
<!--                    <div class="moduleCen">-->
<!--                    <div>-->
<!--                        <div style="margin-bottom: 2px;color: #b2b1b1">30 Days</div>-->
<!--                        <div style="font-weight: 600">$30.00</div>-->
<!--                    </div>-->
<!--                    </div>-->
<!--                    <div class="moduleFoot">-->
<!--                    <b-button block variant="primary">Rent number</b-button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                </b-col>-->
<!--            </b-row>-->

          </b-container>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<style scoped>
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;
  }
}
.line{
  padding:10px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  font-weight: 600;
}
.line2{
  padding:10px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}
.line:hover{
  background-color: #f3f3f3;
  cursor: pointer;
}
.leftMesBox{
  height: 1000px;
  box-shadow: 0 0.5em 1em -0.125em #0a0a0a1a, 0 0 0 1px #0a0a0a05;
  padding: 30px 20px;
  box-sizing: border-box;
}
.mesModule{
  border-bottom: 1px solid #cccccc;
  padding: 10px 20px;
  box-sizing: border-box;
}
.mesModuleText1{
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
}
.mesModuleText2{

}

.onlineModule1{
  border-radius: 5px;
  background-color: #48C78E;
  color: #FFFFFF;
  width: 60px;
  padding: 4px 0px;
  text-align: center;
  margin: 0 auto;
  font-size: 12px;
}
.phoneModule1{
  width: 160px;
  margin: 10px auto;
}
.module1{
  width: 100%;
  box-shadow: 0 0.5em 1em -0.125em #0a0a0a1a, 0 0 0 1px #0a0a0a05;
  padding: 20px 10px;
  box-sizing: border-box;
}
.headModule1{
  width: 110px;
  height: 50px;
  border-radius: 10px;
  background-color: #f8f7f7;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  box-sizing: border-box;
  margin: 0 auto;
}
.moduleFoot{
  padding: 0 16px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.moduleCen{
  margin: 4px 0 ;
  padding: 10px 15px;
  box-sizing: border-box;
}
.module{
  border: 1px solid #efeeee;
  border-radius: 10px;
}
.moduleHead{
  padding: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #2080E4;
  background-color: rgba(32,128,228,0.1);
  display: flex;
  border-radius: 5px 5px 0 0 ;
}
</style>



// WEBPACK FOOTER //
// src/view/profile.vue